var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('inventories')}}),_c('v-progress-linear',{attrs:{"color":"accent","indeterminate":"","active":_vm.loading}}),_c('inventory-list-card',{attrs:{"item-route-name":"inventory-management-app-inventory","inventories":_vm.inventories,"hide-title-bar":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }